// eslint-disable-next-line import/prefer-default-export, no-shadow
  export enum QoutesActionTypes {
    GET_COMPREHENSIVE_AND_THIRD_PARTY = 'GET_COMPREHENSIVE_AND_THIRD_PARTY',
    GET_COMPARE_QOUTES = 'GET_COMPARE_QOUTES',
    SEND_CHEAPEST_QUOTES = 'SEND_CHEAPEST_QUOTES',
    GET_BIKE_COMPARE_QUOTES = 'GET_BIKE_COMPARE_QUOTES',
    SEND_BIKE_CHEAPEST_QUOTES = 'SEND_BIKE_CHEAPEST_QUOTES',
  }
  